import { Field } from 'formik';
import { FormikRadioGroup } from '@flexinet/ui-components';
import { ProductStatus } from '../../types';

export const FilterFormComponent = () => {
    const statusOptions = [
        { value: '', label: 'All Statuses' },
        { value: ProductStatus.Active, label: 'Active' },
        { value: ProductStatus.Draft, label: 'Draft' },
        { value: ProductStatus.Deprecated, label: 'Deprecated' },
    ];

    return (
        <Field
            name="status"
            label="Status"
            data={statusOptions}
            component={FormikRadioGroup}
            my="md"
        />
    );
};
